//====== MEDIA QUERY VARIABLES ======//
export const tablet_max_width = '767px';